import moment from 'moment-timezone';
import vClickOutside from 'v-click-outside-x';
import CorrectDatepicker from '@/components/correct-datepicker/CorrectDatepicker.vue';
import { localDateToApi } from '@/util/helper';

export default {
  props: {
    value: String,
    disabled: Object,
  },
  components: {
    datepicker: CorrectDatepicker,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      dateMomentValue: moment(this.value),
      isTimepickerVisible: false,
      hourOptions: this.getTimeOptions(24),
      minutesOptions: this.getTimeOptions(60),
    };
  },
  computed: {
    datepickerInternalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.dateMomentValue = localDateToApi(new Date(value))
          .clone()
          .set('hour', this.hourValue)
          .set('minute', this.minuteValue);
      },
    },
    hourValue: {
      get() {
        return this.dateMomentValue.format('HH');
      },
      set(value) {
        this.dateMomentValue = this.dateMomentValue.clone().set('hour', value);
      },
    },
    minuteValue: {
      get() {
        return this.dateMomentValue.format('mm');
      },
      set(value) {
        this.dateMomentValue = this.dateMomentValue.clone().set('minute', value);
        this.isTimepickerVisible = false;
      },
    },
    timeString() {
      return this.dateMomentValue.format('HH:mm');
    },
  },
  methods: {
    getTimeOptions(max) {
      const result = [];
      for (let i = 0; i < max; i += 1) {
        if (i < 10) {
          result.push({ text: `0${i}`, value: `0${i}` });
        } else {
          result.push({ text: i, value: i });
        }
      }
      return result;
    },
    toggleTimeSettings() {
      this.isTimepickerVisible = !this.isTimepickerVisible;
    },
    hideDatepicker() {
      this.$refs.datepickerComp.hideDatepicker();
    },
    hideTimePicker() {
      this.isTimepickerVisible = false;
    },
  },
  watch: {
    dateMomentValue: function watchDateMomentValue(newDate) {
      this.$emit('input', newDate.toISOString());
    },
    value: function watchValue(val) {
      this.dateMomentValue = moment(val);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/datetimepicker/DateTimePicker.js